var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ReportTemplate',{attrs:{"loading":!_vm.initialized,"title":"Inventory Adjustment Report","filters":_vm.filters,"columns":_vm.columns,"permission":_vm.PERMISSION_CODES.CMS_VIEW_REPORT_INVENTORY_ADJUSTMENT,"fetchRoute":"/reports/inventory-adjustments","reportTypeCode":_vm.REPORT_MASTER_CODES.INVENTORY_ADJUSTMENT}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }